import { createContext } from "react";
import { LayoutType } from "../../config/global";

const LayoutContext = createContext({
    layout: "horizontal",
    changeLayout: (layout: LayoutType) => {}
})

export default LayoutContext